import api from 'api/api.config';

import { buildQueryParams } from 'helpers/api/build-query-params';
import type {
  SortDirection,
  FilterValue,
} from 'helpers/api/build-query-params';
import { parsePaginationHeaders } from 'helpers/api/parse-pagination-headers';

import type { CollectionResponse } from 'api/market-view-api';

const getBasePath = (userId: string, clientId: string | number): string =>
  `/${userId}/clients/${clientId}/reports`;

export interface ClientReportsListParams {
  pageSize?: number;
  pageIndex?: number;
  sortBy?: SortDirection[];
  filters?: Record<string, FilterValue> | null;
}

export const getClientReportsList = async (
  userId: string,
  clientId: string | number,
  params: ClientReportsListParams = {}
): Promise<CollectionResponse> => {
  const { pageSize, pageIndex = 0, sortBy, filters } = params;

  const response = await api.get(getBasePath(userId, clientId), {
    params: buildQueryParams({
      pageSize,
      pageIndex,
      sortBy,
      filters,
      searchTerms: undefined,
      forceSearch: undefined,
    }),
  });

  return {
    data: response.data,
    pagination: parsePaginationHeaders(response.headers, {
      pageIndex,
      pageSize,
    }),
  };
};
